import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Store } from '@ngxs/store';
import { Observable, throwError } from 'rxjs';
import * as Sentry from '@sentry/angular';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  httpErrorSentryExtra,
  shouldReportHttpErrorToSentry,
  toSentryHttpError,
} from '../utils/sentry-http-error.util';

@Injectable()
export class SentryInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const url = request.url ?? '';
        const reportedByForm =
          url.includes('/mailer/contact') ||
          url.includes('/mailer/cooperation');

        if (
          environment.SENTRY_MONITORING &&
          !reportedByForm &&
          shouldReportHttpErrorToSentry(error)
        ) {
          Sentry.captureException(toSentryHttpError(error), {
            tags: {
              http_status: String(error.status),
            },
            extra: {
              ...httpErrorSentryExtra(error, request),
              warrantyCreatorState: (
                this.store.snapshot() as {
                  warrantyCreatorState?: unknown;
                }
              ).warrantyCreatorState,
              warrantyOfferState: (
                this.store.snapshot() as {
                  warrantyOfferState?: unknown;
                }
              ).warrantyOfferState,
            },
          });

          // Workaround for disabling envelopes in sentry
          Sentry.onLoad(() => {
            const envelopes = document.querySelectorAll(
              '.sentry-error-embed-wrapper',
            );
            envelopes.forEach((envelope) => {
              envelope['style'].display = 'none';
            });
          });
        }
        return throwError(error);
      }),
    );
  }
}
